//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateSection from "@Shared/components/sections/date-section";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    DateSection
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    title: {
      type: String,
      required: true
    },
    colSize: {
      type: String,
      default: "4"
    },
    type: {
      type: String,
      default: "text"
    },
    mask: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value);
    }
  }
});